import create from "zustand";
import { persist } from "zustand/middleware";

// define the store
const authStore = create(
  persist(
    (set, get) => ({
      auth: null,
      showDeleteBox: false,
      setAuthData: (params) => {
        set(() => ({
          auth: params,
        }));
      },
      clearAuthData: () => {
        set(() => ({
          auth: null,
        }));
      },
      openDeleteBox: () => {
        set(() => ({
          showDeleteBox: true,
        }));
      },
      hideDeleteBox: () => {
        set(() => ({
          showDeleteBox: false,
        }));
      },
    }),
    { name: "auth" }
  )
);

export default authStore;
